module.exports = __webpack_public_path__ + "img/c02_unitelephantarcher_Normal_ua.a90ef5db.webp";